"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondVisitDefaultQuestionOptions = exports.getKnowYouStep = exports.shareStep = exports.parseChatbotAnalyticsFromFirestore = exports.parseChatbotResultsFromFirestore = exports.parseChatbotFromFirestore = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const models_1 = require("../models");
const uuid_1 = require("uuid");
const utils_1 = require("./utils");
const parseChatbotFromFirestore = (snapshot) => {
    var _a, _b, _c;
    const data = snapshot.data();
    if (!data) {
        throw Error("Couldn't parse chatbot from firestore");
    }
    const publishId = data.publishId;
    return {
        version: 1,
        createdDate: data.createdDate.toDate(),
        modifiedDate: data.modifiedDate.toDate(),
        id: data.id,
        publishId,
        name: data.name,
        owner: data.owner,
        font: data.font,
        guestAvatar: data.guestAvatar,
        hostAvatar: data.hostAvatar,
        language: data.language,
        steps: parseSteps(data),
        themeColors: data.themeColors,
        settings: data.settings
            ? parseSettings(data.settings)
            : {
                showLiteBadge: true,
                showCreateYourOwnButton: true,
                receiveEmailNotifications: true,
            },
        variables: parseVariables(data),
        connectors: data.connectors,
        embedHref: data.embedHref,
        embedHrefs: data.embedHrefs,
        webhook: data.webhook,
        webhooks: data.webhooks,
        collaborators: (_a = data.collaborators) !== null && _a !== void 0 ? _a : [],
        customDomains: (_b = data.customDomains) !== null && _b !== void 0 ? _b : [],
        isPublished: (_c = data.isPublished) !== null && _c !== void 0 ? _c : (0, utils_1.isDefined)(publishId),
        metaData: data.metaData,
        folderId: data.folderId,
        startConditions: data.startConditions,
        supabaseId: data.newId,
    };
};
exports.parseChatbotFromFirestore = parseChatbotFromFirestore;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const parseChatbotResultsFromFirestore = (doc) => {
    var _a, _b, _c, _d;
    return {
        id: doc.id,
        createdDate: (_a = doc.data().createdDate) === null || _a === void 0 ? void 0 : _a.toDate(),
        chatbotId: doc.data().chatbotId,
        timeSpent: doc.data().timeSpent,
        data: doc.data().data,
        completed: (_b = doc.data().completed) !== null && _b !== void 0 ? _b : false,
        starterVariables: (_c = doc.data().starterVariables) !== null && _c !== void 0 ? _c : [],
        hidden: (_d = doc.data().hidden) !== null && _d !== void 0 ? _d : false,
    };
};
exports.parseChatbotResultsFromFirestore = parseChatbotResultsFromFirestore;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const parseChatbotAnalyticsFromFirestore = (doc) => {
    return {
        id: doc.id,
        chatbotId: doc.data().chatbotId,
        averageTimeSpent: doc.data().averageTimeSpent,
        totalAnsweredQuestions: doc.data().totalAnsweredQuestions,
        totalCompleted: doc.data().totalCompleted,
        totalResults: doc.data().totalResults,
        totalSessions: doc.data().totalSessions,
        questions: doc.data().questions,
        embedLocations: doc.data().embedLocations,
    };
};
exports.parseChatbotAnalyticsFromFirestore = parseChatbotAnalyticsFromFirestore;
const parseSettings = (settings) => (Object.assign(Object.assign({}, settings), { refreshFirstStep: settings.refreshFirstStep
        ? Object.assign(Object.assign({}, settings.refreshFirstStep), { value: settings.refreshFirstStep.value
                ? Object.assign(Object.assign({}, settings.refreshFirstStep.value), { questionOptions: parseQuestionOptions(settings.refreshFirstStep.value.questionOptions) }) : null }) : null }));
const parseSteps = (data) => {
    return data.steps.map((step) => (Object.assign(Object.assign({}, step), { questionOptions: parseQuestionOptions(step.questionOptions), logicJumps: parseLogicJumps(step.logicJumps, data.steps) })));
};
const parseQuestionOptions = (questionOptions) => {
    var _a;
    if (!questionOptions ||
        !questionOptions.items ||
        ((_a = questionOptions.items) === null || _a === void 0 ? void 0 : _a.length) === 0)
        return questionOptions;
    return Object.assign(Object.assign({}, questionOptions), { items: questionOptions.items.map((item) => {
            var _a;
            if (item.url)
                return Object.assign(Object.assign({}, item), { id: (_a = item.id) !== null && _a !== void 0 ? _a : (0, uuid_1.v4)() });
            if (item.id)
                return item;
            return {
                value: item,
                id: (0, uuid_1.v4)(),
            };
        }) });
};
const parseLogicJumps = (logicJumps, steps) => {
    var _a, _b, _c;
    if (!logicJumps)
        return null;
    let defaultThen = logicJumps === null || logicJumps === void 0 ? void 0 : logicJumps.defaultThen;
    if (logicJumps === null || logicJumps === void 0 ? void 0 : logicJumps.defaultTargetId) {
        defaultThen = { targetId: logicJumps === null || logicJumps === void 0 ? void 0 : logicJumps.defaultTargetId };
    }
    if (logicJumps === null || logicJumps === void 0 ? void 0 : logicJumps.defaultTargetIndex) {
        if (typeof logicJumps.defaultTargetIndex === "string") {
            defaultThen = { targetId: logicJumps.defaultTargetIndex };
        }
        else {
            defaultThen = {
                targetId: (_b = (_a = steps[logicJumps.defaultTargetIndex]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
            };
        }
    }
    return {
        defaultThen,
        conditions: (_c = parseConditions(logicJumps === null || logicJumps === void 0 ? void 0 : logicJumps.conditions, steps)) !== null && _c !== void 0 ? _c : undefined,
    };
};
const parseConditions = (conditions, steps) => {
    if (!conditions)
        return null;
    return conditions.map((condition) => {
        var _a, _b, _c;
        const then = (_a = condition.then) !== null && _a !== void 0 ? _a : { targetId: null };
        if (condition === null || condition === void 0 ? void 0 : condition.targetIndex) {
            if (typeof condition.targetIndex === "string") {
                then.targetId = condition.targetIndex;
            }
            else {
                then.targetId = (_c = (_b = steps[condition.targetIndex]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
            }
        }
        return Object.assign(Object.assign({}, condition), { comparisons: parseComparisons(condition.comparisons, steps), then });
    });
};
const parseComparisons = (comparisons, steps) => {
    return comparisons.map((comparison) => {
        var _a, _b, _c;
        const input = (_a = comparison.input) !== null && _a !== void 0 ? _a : { questionId: null };
        if (comparison === null || comparison === void 0 ? void 0 : comparison.questionIndex) {
            if (typeof comparison.questionIndex === "string") {
                input.questionId = comparison.questionIndex;
            }
            else {
                input.questionId = (_c = (_b = steps[comparison.questionIndex]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
            }
        }
        if (comparison.variableId) {
            input.variableId = comparison.variableId;
        }
        return Object.assign(Object.assign({}, comparison), { input });
    });
};
const parseVariables = (data) => {
    if (data.variables) {
        return data.variables;
    }
    let starterVariables = [];
    if (data.starterVariables) {
        starterVariables = data.starterVariables.map((variable) => (Object.assign(Object.assign({}, variable), { name: variable.label })));
    }
    const questionVariables = data.steps
        .filter((step) => step.saveAnswerVariableName !== "0")
        .map((step) => ({
        id: (0, uuid_1.v4)(),
        stepId: step.id,
        name: step.saveAnswerVariableName,
    }));
    return {
        starterVariables,
        questionVariables,
        computationVariables: [],
    };
};
const shareStep = (chatbot, t) => {
    return {
        id: "last-id",
        answerType: models_1.InputType.SHARE,
        questionMessages: [
            {
                id: "questionLastId",
                value: t("Dont hesitate to share"),
            },
        ],
        chatbotStepIndex: chatbot.steps.length,
    };
};
exports.shareStep = shareStep;
const getKnowYouStep = (t) => ({
    id: "i-know-you",
    answerType: models_1.InputType.SINGLE_SELECT,
    questionMessages: [
        {
            id: "i-know-you-0",
            value: t("this-is-not-the-first-time-you-are-here"),
        },
        {
            id: "i-know-you-1",
            value: t("what-would-you-like-to-do"),
        },
    ],
    questionOptions: (0, exports.secondVisitDefaultQuestionOptions)(t),
    chatbotStepIndex: -1,
});
exports.getKnowYouStep = getKnowYouStep;
const secondVisitDefaultQuestionOptions = (t) => ({
    items: [
        { id: "start-again-item-id", value: t("start-again") },
        { id: "continue-item-id", value: t("Continue") },
    ],
});
exports.secondVisitDefaultQuestionOptions = secondVisitDefaultQuestionOptions;
//# sourceMappingURL=chatbot.js.map